/*
セレクトボックスを切り替えると、optionのdata-hrefに遷移する

<select name="news_category" class="js-selectJump">
    <option data-href="/news/">
        すべて
    </option>
    <option value="" data-href="/news/?news_category=2">
        コラム
     </option>
    <option value="" data-href="/news/?news_category=1">
        お知らせ
    </option>
</select>
*/
if (document.getElementsByClassName('js-selectJump')[0]) {
  module()
}
function module() {
  window.addEventListener('change', function (e) {
    const item = e.target.closest('.js-selectJump')
    if (!item) {
      return
    }
    const selectOption = item.options[item.selectedIndex]

    // console.log(selectOption)

    window.location.href = selectOption.dataset.href
  })
}
